import { render } from "./tableList.vue?vue&type=template&id=59cd055d&scoped=true"
import script from "./tableList.vue?vue&type=script&lang=js"
export * from "./tableList.vue?vue&type=script&lang=js"

import "./tableList.vue?vue&type=style&index=0&id=59cd055d&scoped=true&lang=css"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59cd055d"]])

export default __exports__